import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { PageHero, SectionLabel } from "../components/site/Bits";
import Reveal from "../components/site/Reveal";
import { IMAGES, DOMESTIC_SERVICES, DOMESTIC_INCLUDED } from "../data/content";

export default function DomesticCleaning() {
  return (
    <div data-testid="domestic-cleaning-page">
      <PageHero
        crumb="Domestic Cleaning"
        label="Domestic Cleaning"
        title="A spotless home, handled with care."
        subtitle="From weekly upkeep to full deep cleans and end of tenancy — flexible, reliable cleaning across Preston."
        image={IMAGES.cleanHome}
      />

      <section className="py-24 lg:py-32 bg-white">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid gap-16 lg:grid-cols-2 lg:gap-24">
          {/* Services */}
          <div>
            <Reveal><SectionLabel>Services</SectionLabel></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-heading font-extrabold text-navy text-3xl sm:text-4xl tracking-tighter">
                What we clean
              </h2>
            </Reveal>
            <ul className="mt-8 divide-y divide-black/5 border-y border-black/5">
              {DOMESTIC_SERVICES.map((s, i) => (
                <Reveal key={s} delay={i * 0.03}>
                  <li className="flex items-center gap-4 py-4 group">
                    <span className="text-xs text-brandgreen font-semibold w-6">{`0${i + 1}`.slice(-2)}</span>
                    <span className="font-heading font-medium text-navy text-lg tracking-tight group-hover:text-brandgreen transition-colors">
                      {s}
                    </span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>

          {/* What's included */}
          <div>
            <Reveal><SectionLabel>What's Included</SectionLabel></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-heading font-extrabold text-navy text-3xl sm:text-4xl tracking-tighter">
                Every visit covers
              </h2>
            </Reveal>
            <div className="mt-8 grid sm:grid-cols-2 gap-3">
              {DOMESTIC_INCLUDED.map((item, i) => (
                <Reveal key={item} delay={i * 0.04}>
                  <div className="flex items-center gap-3 rounded-xl bg-mist p-4">
                    <span className="grid place-items-center w-7 h-7 rounded-full bg-brandgreen text-white shrink-0">
                      <Check className="w-4 h-4" strokeWidth={3} />
                    </span>
                    <span className="text-navy font-medium">{item}</span>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.1}>
              <div className="mt-10 rounded-2xl bg-navy text-white p-8">
                <h3 className="font-heading font-bold text-2xl tracking-tight">Need a tailored clean?</h3>
                <p className="mt-2 text-white/70 text-sm leading-relaxed">
                  Tell us what you need and we'll send you a free, no-obligation quote.
                </p>
                <Link
                  to="/contact"
                  data-testid="domestic-request-quote"
                  className="mt-6 inline-flex items-center gap-2 rounded-full bg-brandgreen px-7 py-3.5 font-semibold hover:bg-white hover:text-navy transition-colors duration-300"
                >
                  Request a Quote <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
